import { AppStore } from "../../store/modules/app";
import { PersonStore } from "../../store/modules/person";
import { ContractsStore } from "../../store/modules/contracts";
import { DiTokens } from "../../services/diTokens";
import IAlertService from "../../services/alert/IAlertService";
import { Vue, Watch, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import ISubscriptionService from "../../services/subscription/ISubscriptionService";
import { UserSubscriptionData } from '../../data/userSubscriptionData';
import { UserDocumentData } from '../../data/userDocumentData';
import { OperationRequestData } from '../../data/operationRequestData';
import { DeclarationPropertiesTypes } from '../../data/enums/declarationPropertiesTypes';
import { OperationsApi } from '../../services/api/OperationsApi';
import {DocumentTypeData} from '../../data/documentTypeData';
import { container } from "@/inversify.config";
import i18n from "@/i18n";
import { ConfigApi } from "fs-pb-vue2/services/api/ConfigApi";
import { ContractModel } from "fs-pb-vue2/models/contracts/contractModel";
import { ContractsTypes } from "fs-pb-vue2/data/enums/contractsTypes";
import { ConfigStore } from "fs-pb-vue2/store/modules/config";

export class SubscriptionEditVue extends Vue {

  // stores:

  /** Стор приложения */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }

  /** Стор приложения */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  /** Стор приложения */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**
 * Хранилище конфигураций
  * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  // services:

  get subService(): ISubscriptionService {
    return container.get<ISubscriptionService>(DiTokens.SubscriptionService);
  }

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }


  // props:

  @Prop() item!: UserSubscriptionData;

  @Prop() isNew!: boolean;

  // watchers:

  @Watch('item', { immediate: true })
  newItem(val: any): void {
    this.fillData(val);
  }

  @Watch('docType', { immediate: true })
  docTypeChanged(val: any): void {
    if (val && val.Code) {
      if (!this.isNew) {
        if (this.item && this.item.Document) {
          if (val.Code === this.item.Document.Type.Code) {
            this.$nextTick(() => {
              this.subscription.docNumber = this.item.Document.Number;
            });
          } else {
            this.$nextTick(() => {
              this.subscription.docNumber = '';
            });
          }
        }
      } else {
        this.$nextTick(() => {
          this.subscription.docNumber = '';
        });
      }
    }
  }

  // data:

  selectedCategory: any = null;

  loading: boolean = false;
  
  newId: string = '';
    
  subscription: any = {
    name: "",
    docNumber: "",
    active: false,
    autoExec: false,
    docType: {},
    docMask: "",
    contract: {},
  };

  tariffDialog: boolean = false;

  needConfirm: boolean = false;

  confirmCode: string = '';
  
  isValidForm: boolean = false;
  
  operId: number = 0;

  catImages: Array<any> = [];

  /**Правила заполнения имени */
  nameRules: Array<any> = [
    (v: any) => !!v || i18n.t("main.templates.nameNecessarily"),
    (v: any) => (v && v.length <= 50) || i18n.t("main.templates.nameLong"),
    (v: any) =>
      (!!v && v[0].split(" ").length <= 1) ||
      i18n.t("main.templates.nameSpace"),
  ];

  docNumberRules: Array<any> = [
    (v: any) =>
      (!!v && v[0].split(" ").length <= 1) || "Введите номер документа",
    (v: any) =>
      (v && v.length <= 50) ||
      "Номер документа должен быть меньше 50 символов",
  ];

  docTypeRules: Array<any> = [
    (v: any) =>
      (!!v && !!v.Code && !!v.DisplayName) || "Выберите тип документа",
  ];

  contractRules: Array<any> = [
    (v: any) => (!!v && !!v.Data?.ReferenceId) || "Выберите счет списания",
  ];

  // computed:

  get docNumLabel(): string {
    return this.subscription.docType?.DisplayName || "Номер документа";
  };

  get mask(): string {
    return this.subscription.docType?.Mask || "";
  };

  get docType(): any {
    return this.subscription.docType;
  };

  get docNum(): any {
    return this.subscription.docNumber;
  };

  get codeRules(): Array<Function> {
    return [
      () => {
        const regex: RegExp = new RegExp(/^[\d]{4,6}$/);
        return (
          regex.test(this.confirmCode) ||
          i18n.t("main.operation.errors.invalidCode")
        );
      },
    ];
  };

  get docCategories(): Array<any> {
    const res: Array<any> = [];
    this.personStore.userDocTypes.map((docType: DocumentTypeData) => {
      if (!res.find((i: any) => i.cat == docType.Category))
        res.push({ cat: docType.Category, img: this.catImages.find((img: any) => img.category == docType.Category)?.imageWeb });
    })
    return res;
  }

  get docTypesByCategory(): Array<DocumentTypeData> {
    if (this.selectedCategory)
      return this.personStore.userDocTypes.filter((docType: DocumentTypeData) => docType.Category === this.selectedCategory.cat);
    return this.personStore.userDocTypes;
  }

  get docTypes(): any {
    return this.personStore.userDocTypes;
  };

  get caption(): any {
    if (!this.subscription) return "";
    if (
      !this.subscription.docType.Category ||
      this.subscription.docType.Category == "Не определенный платеж"
    )
      return "Новый шаблон";
    return this.subscription.docType.Category;
  };

  get contracts(): any {
    return this.contractsStore.contracts.getContractsByFilter(9).filter((contract: ContractModel) => 
      !contract.Data.Hidden && contract.Data.ContractType == ContractsTypes.CardAccount && contract.Data.CurrencyCharCode == "RUR" && contract.Data.DisposableLimit > 0
    );
  };

  get isVip(): boolean {
    return this.personStore.personInfo?.Data?.Vip;
  }

  // methods:

  async getCategorysImages(): Promise<void> {
    try {
      const respData: any = await ConfigApi.getSubscriptionCategoryImages(this.configStore.apiData.DocumentTypeCategoriesImageFile);
      
      this.catImages = respData;
    } catch (e: any) {
      this.alertService.error(e.message);
    }
  }

  fillData(value: any): void {
    if (this.isNew || !value || !value.Document) {
      this.clearForm();
      return;
    }
    this.subscription.name = value.Document.Name;
    this.subscription.docType = value.Document.Type;
    this.subscription.docNumber = value.Document.Number;
    this.subscription.active = value.Active;
    this.subscription.autoExec = value.AutoExecute;
    if (value.AutoExecute && this.contractsStore.contracts)
      this.subscription.contract =
        this.contractsStore.contracts.getContractByRefId(value.Contract);
  };

  cencel(): void {
    if (this.$refs.subsForm) this.$refs.subsForm.resetValidation();
    this.$emit("cencel");
  };

  selectCategory(cat: any): void {
    this.selectedCategory = cat;
    this.subscription.docType.Category = cat.cat;
  }

  prepareSaveOrder(subscription: UserSubscriptionData, ord: OperationRequestData): OperationRequestData {
    ord.respondentCode = "";
    ord.setProperty(
        "Name",
        subscription.Document.Name,
        DeclarationPropertiesTypes.String
    );
    ord.setProperty(
        "Number",
        subscription.Document.Number.toString(),
        DeclarationPropertiesTypes.String
    );
    ord.setProperty(
        "Code",
        subscription.Document.Type.Code.toString(),
        DeclarationPropertiesTypes.Int
    );
    ord.setProperty(
        "Active",
        subscription.Active.toString(),
        DeclarationPropertiesTypes.Boolean
    );
    ord.setProperty(
        "AutoExecute",
        subscription.AutoExecute.toString(),
        DeclarationPropertiesTypes.Boolean
    );

    if (subscription.Contract)
        ord.setProperty("Contract", subscription.Contract.toString(), DeclarationPropertiesTypes.String);

    return ord; 
  }

  prepareEditOrder(subscription: UserSubscriptionData, ord: OperationRequestData): OperationRequestData {
    ord.respondentCode = "";
    ord.setProperty(
        "Name",
        subscription.Document.Name,
        DeclarationPropertiesTypes.String
    );
    ord.setProperty(
        "subscriptionId",
        subscription.Id.toString(),
        DeclarationPropertiesTypes.Int
    );
    ord.setProperty(
        "Number",
        subscription.Document.Number.toString(),
        DeclarationPropertiesTypes.String
    );
    ord.setProperty(
        "Code",
        subscription.Document.Type.Code.toString(),
        DeclarationPropertiesTypes.Int
    );
    ord.setProperty(
        "Active",
        subscription.Active.toString(),
        DeclarationPropertiesTypes.Boolean
    );
    ord.setProperty(
        "AutoExecute",
        subscription.AutoExecute.toString(),
        DeclarationPropertiesTypes.Boolean
    );

    ord.setProperty("Contract", subscription.Contract.toString(), DeclarationPropertiesTypes.String);

    return ord;
  }

  async submitHandler() {
    try {
      await this.$refs.subsForm.validate();

      if (!this.isValidForm) return;

      this.loading = true;
      const savedItem: UserSubscriptionData = this.fillRequest();
      let ord: OperationRequestData = new OperationRequestData();
      let ordResp: any = new OperationRequestData();

      if (this.needConfirm) {
        ord.verificationCode = this.confirmCode;
        ord.operationId = this.operId;
      }

      if (this.isNew) {
        if (this.newId)
          ord.setProperty("subscriptionId", this.newId, DeclarationPropertiesTypes.String)
        ord = this.prepareSaveOrder(savedItem, ord);
        ordResp = await OperationsApi.operationSendAsync(
          'WebClient/SaveUserSubscription',
          ord
        );
        ordResp = new OperationRequestData(ordResp.data);
        this.newId = ordResp.getPropertyValue("subscriptionId");
      }
      else {
        if (!this.checkChanges()) {
          this.alertService.warning('Вы не произвели никаких изменений');
          this.loading = false;
          return;
        }
        ord = this.prepareEditOrder(savedItem, ord);
        ordResp = await OperationsApi.operationSendAsync(
          "WebClient/EditUserSubscription",
          ord
        );
        ordResp = new OperationRequestData(ordResp.data);
      }
      if (this.needConfirm || !ordResp.needConfirm) {
        this.alertService.success('Шаблон успешно сохранен');
        await this.personStore.fetchSubscriptions();
        this.cencel();
      } else {
        this.needConfirm = true;
        this.operId = ordResp.operationId;
      }

      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.alertService.error(e.message);
    }
  };

  fillRequest(): UserSubscriptionData {
    const savedItem: UserSubscriptionData = new UserSubscriptionData();
    if (!this.isNew) savedItem.copy(this.item);
    if (!savedItem.Document) {
      savedItem.Document = new UserDocumentData();
      savedItem.Document.Type = new DocumentTypeData();
    }
    savedItem.Document.Name = this.subscription.name;
    savedItem.Document.Number = this.subscription.docNumber;
    savedItem.Active = this.subscription.active;
    savedItem.AutoExecute = this.subscription.autoExec;
    savedItem.Document.Type = this.subscription.docType;
    if (savedItem.AutoExecute)
      savedItem.Contract = this.subscription.contract.Data.ReferenceId;
    return savedItem;
  };

  clearForm(): void {
    this.subscription.name = "";
    this.subscription.docNumber = "";
    this.subscription.active = false;
    this.subscription.autoExec = false;
    this.subscription.docType = new DocumentTypeData();
    this.subscription.contract = this.contracts.length
      ? this.contracts[0]
      : {};
    this.needConfirm = false;
    this.confirmCode = "";
  };

  /**Проверяем менялись ли данные true - менялись */
  checkChanges(): boolean {
    return (
      !this.item?.Document ||
      !this.subscription ||
      this.subscription.name !=
        (this.item as UserSubscriptionData).Document.Name ||
      this.subscription.docNumber !=
        (this.item as UserSubscriptionData).Document.Number ||
      this.subscription.active !=
        (this.item as UserSubscriptionData).Active ||
      this.subscription.autoExec !=
        (this.item as UserSubscriptionData).AutoExecute ||
      this.subscription.docType.Code !=
        (this.item as UserSubscriptionData).Document.Type.Code ||
      (this.subscription.autoExec &&
        this.subscription.contract.Data?.ReferenceId !=
          (this.item as UserSubscriptionData).Contract)
    );
  };

  autoExecChange(): void {
    if (this.subscription.autoExec) 
      this.tariffDialog = true;
  };

  cencelAutoExec(): void {
    this.subscription.autoExec = false;
    this.tariffDialog = false;
  };

}
